export default "__VITE_PUBLIC_ASSET__3364462a__"